export default {
  namespaced: true,
  state: {
    documentation: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_DOCUMENTATION(state, documentation) {
      state.documentation = documentation
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    // Actions à implémenter
  }
} 